import { animate, state, style, transition, trigger } from '@angular/animations';

export const toggleHeightAnimation = trigger('toggleHeight', [
  state(
    'in',
    style({
      opacity: 1,
      height: '*',
      paddingTop: '*',
    }),
  ),
  state(
    'void',
    style({
      opacity: 0,
      height: '0px',
      paddingTop: '0px',
    }),
  ),
  transition('* <=> *', [animate('0.3s cubic-bezier(.25, .8, .25, 1)')]),
]);
